import * as joint from "jointjs";

type Placement = {
  distance: number | string;
  offset: number;
};

// A tool instance belongs to the link view it was added to, so a new one is built for
// every link. The placement is handed in because it depends on the link length.
export const createEditLinkTool = (placement: Placement) =>
  new joint.linkTools.Button({
    markup: [
      {
        tagName: "circle",
        selector: "button",
        attributes: {
          r: 7,
          fill: "#35495d",
          cursor: "pointer",
        },
      },
      {
        tagName: "path",
        selector: "icon",
        attributes: {
          d: "M -3 -4 L 3 -4 M -3 -4 L -3 4 M -3 0 L 2 0 M -3 4 L 3 4",
          fill: "none",
          stroke: "#FFFFFF",
          "stroke-width": 2,
          "pointer-events": "none",
        },
      },
    ],
    distance: placement.distance,
    offset: placement.offset,
    action: function (_evt) {
      // @ts-ignore
      (this.paper as KEAPaper)?.nodeClb(this.model);
    },
  });
